// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-card-meta-detail {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n\n.swal-button {\n  background-color: #1890ff;\n}\n\n.swal-button:not([disabled]):hover {\n  background-color: none;\n}\n", ""]);
// Exports
module.exports = exports;
